import { App } from '@amzn/monera-app/lib/pages/_app';
import { reportWebVitals as reportWebVitalsAPI } from '@amzn/monera-app/lib/pages/_app';

import '../styles/debug-fix.css';

/**
 * Next.js locates its page data and render container by fixed DOM ids (`__NEXT_DATA__`, `__next`) via getElementById, which returns the first match in document order. The UPX Select payment widget (a second Next.js app injected into this page by the Prime signup flow) therefore reads OUR page data and mounts into OUR root, replacing the page. See V2335619814.
 *
 * This module-scope block releases both ids the moment Next.js evaluates our app bundle. Ordering is guaranteed by Next's boot sequence (verified in next@12.3.6 dist/client/index.js): initialize() reads the data element and captures the `__next` node in one synchronous block (lines 116/177); only afterwards does hydrate() execute this module and render.
 *
 * So this runs after Next's only reads of these ids and before hydration/first paint — the widget, whose boot requires a post-hydration click plus several network hops, can never observe the standard ids here.
 */
if (typeof window !== 'undefined') {
  const nd = document.getElementById('__NEXT_DATA__');
  if (nd) {
    nd.id = '__NEXT_DATA_MONERA__';
  }
  const root = document.getElementById('__next');
  if (root) {
    root.setAttribute('data-next-root', 'monera');
    root.id = '__next_monera__';
  }
}

export default App;
export const reportWebVitals = reportWebVitalsAPI;
